import { gsap } from "gsap"
import ModalVideo from "modal-video";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import { newsTicker } from './global'

import Swiper from "swiper"
import {Autoplay, Navigation} from "swiper/modules";
import {selectAllEl, selectEl} from "./utils";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

let learnMoreSlider = null;

window.addEventListener('load', function() {
    newsTicker()
    initDocSlider()
    initMapHover()
    initDocTestimonialSlider()
    initModal();
    initLearnMoreLinks();
    initLearnMoreSlider();

    new ModalVideo('.js-modal-btn');

    ScrollSmoother.create({
        smooth: 1.5,
        smoothTouch: 0.1
    })
})

function initLearnMoreLinks() {
    const links= selectAllEl('.learn-more-link')
    links.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            const index = link.getAttribute('data-slide-index')
            if(!learnMoreSlider) {
                initModal()
            }
            learnMoreSlider.slideTo(parseInt(index))
        })
    })
}

function initModal() {
    const triggers = selectAllEl('[data-modal]')
    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const selector = trigger.getAttribute('data-modal')
            const modal = selectEl(selector)
            modal && modal.classList.add('modal_show')
            modal.addEventListener('click', e => {
                if(modal === e.target) {
                    modal.classList.remove('modal_show')
                }
            })

            if(!learnMoreSlider) initLearnMoreSlider()

        })
    })
}

function initDocSlider() {
    if(window.innerWidth < 600) return;

    const docSlider = selectEl('.doctors-slider')
    const slide = selectEl('.doctors-slider .swiper-slide')

    docSlider.style.marginRight = `-${docSlider.offsetLeft}px`

    const doctorsSlide = new Swiper(".doctors-slider", {
        slidesPerView: 1.5,
        spaceBetween: 16,
        modules: [Navigation],
        breakpoints: {
            600: {
                slidesPerView: 2.5,
            },

            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        navigation: {
            prevEl: '#prev-doctor',
            nextEl: '#next-doctor',
        }
    });
}

function initDocTestimonialSlider() {

    const doctorsSlide = new Swiper("#testimonial-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        modules: [Navigation, Autoplay],
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: '#prev-testimonial',
            nextEl: '#next-testimonial',
        }
    });
}

function initLearnMoreSlider() {
    learnMoreSlider = new Swiper("#learn-more-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        modules: [Navigation],
        navigation: {
            prevEl: '#prev-learn-more',
            nextEl: '#next-learn-more',
        }
    });
}
function initMapHover() {
    const map = selectEl('#map');
    const offset = -20;
    const tooltip = selectEl('#coming-soon_tooltip');

    map.addEventListener('mousemove',function (event) {
        if (event.target.classList.contains('coming-soon')) {
            const stateName = event.target.getAttribute('id')
            updateTooltipPosition(event);
            tooltip.querySelector('#coming-soon_state').innerHTML = stateName ? stateName?.replace('-', ' ') + ':' : ''
            tooltip.classList.remove('is-hide')
        } else if (event.target.classList.contains('kansas')) { 
            const stateName = event.target.getAttribute('id')
            updateTooltipPosition(event);
            tooltip.querySelector('#coming-soon_state').innerHTML = stateName ? stateName?.replace('-', ' ') + ':' : ''
            tooltip.querySelector('#coming-soon_text').innerHTML = 'Special Requirements'
            tooltip.classList.remove('is-hide')
        } else {
            tooltip.classList.add('is-hide')
        }
    });
    function updateTooltipPosition(event) {
        const rect = map.getBoundingClientRect();

        // Calculate relative position within the #map div
        const mouseXRelativeToMap = event.clientX - rect.left;
        const mouseYRelativeToMap = event.clientY - rect.top - offset;

        tooltip.style.left = mouseXRelativeToMap + 'px';
        tooltip.style.top = mouseYRelativeToMap + 'px';
    }
}




